















































import Vue from 'vue'
import Component from 'vue-class-component'
import TableBasedView from "@/components/TableBasedView.vue"
import {Placeholder} from "@/Models"
import Rules from "@/Rules"

@Component({
  components: {TableBasedView}
})
export default class TagsHash extends Vue {

  headers = [
    {text: 'Name', align: 'start', sortable: true, value: 'name', width: '25%'},
    {text: 'Value', align: 'start', sortable: false, value: 'custom1', width: '75%'},
    {text: 'Actions', align: 'center', value: 'actions', sortable: false}
  ]

  defaultItem = new Placeholder()
  rules = new Rules()

}
